exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-47efda6c]{\n  width: 350px;\n}\n", ""]);

// exports
